module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap-num",
    attrs: {
      "id": "ch03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("3")])]), _vm._v(" "), _c('h2', {
    staticClass: "chap-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Builders")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Modernization of Architecture and City Planning")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Greater Istanbul is full of old mosques, palaces, military quarters, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hamams")]), _vm._v(" (communal bath houses), and former "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("madrasas.")]), _vm._v(" These are well-preserved examples of Ottoman architecture. One can find similar landmarks throughout the Middle East and other outlying districts of the old empire. In the eyes of Turkey’s reformists, however, architecture would provide a very visible symbol of Turkey’s modernization, second only to creating a new alphabet. Moving Turkey’s central government from Istanbul to Ankara, the country’s rural interior was a political message of major proportions. Its implementation, and the visual development of Ankara from ground up as a major city, was another matter. Since the statement needed to be articulated in modern or western design, Ottoman-Turkish architects were not considered for the job ("), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_8"
    }
  }, [_vm._v("Fig. 8")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_9"
    }
  }, [_vm._v("9")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Among the many professors and/or professionals invited was a group of leading architects. In 1938, together with her architect husband, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Margarete Schütte-Lihotzky")]), _vm._v(" was called to Istanbul to teach at the Academy of Fine Arts, and to reunite with exiled German architect Bruno Taut. Schütte-Lihotzky was brought in because she epitomized several of the goals and objectives of the Republic’s fathers. That she was a female was of significance and an important signal sent by the Young Turks in government, who were mostly career army officers. She was the first and, to this day, the most famous, Austrian female architect. She represented the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Neuen Bauens,")]), _vm._v(" New Constructions. Between the World Wars, Schütte-Lihotzky planned and built the New Frankfurt for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wein Siedlerbewegung,")]), _vm._v(" or Vienna Building Society. Significantly, she had already completely planned and designed cities new from ground up. Magnitogorsk, a major industrial center in the Soviet Union’s Ural region of Siberia, was one of them ("), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_10"
    }
  }, [_vm._v("Fig. 10")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v("Schütte-Lihotzky was among the foremost social architects practicing in Europe before World War II. She specialized in designing housing for the working class. Her designs reduced the labor involved in “house labor” of working wives. Her kitchens became the prototype for those in any modern home or apartment worldwide. Just as significantly, in terms of Turkey’s new ideology, she had designed motion-saving kitchens for the home, which she based on Frederick W. Taylor’s time efficiency studies and the motion-efficiency studies of Frank and Lillian Gilbreth. “Schütte-Lihotzky designed the famed Frankfurt kitchen which was functional, inexpensive, and could be mass-produced. Beginning in 1927, the Frankfurt City Council installed 10,000 of her prefabricated kitchens in working-class apartments. Before her innovative design, kitchens were mostly planned for households with servants.” She learned about the Taylor system, a scientific approach to understanding the necessity of accurately measuring the time required for each task performed in a given job in order to better organize work and redesign the workplace so as to increase efficiency. During the 1920s, Taylorism was transforming the industrial workplace in the United States. According to architectural writer Billie Ann Lopez, around 1922, Schütte-Lihotzky “read an essay called “How Can Appropriate Housing Construction Reduce the Work of Housewives” in the Breslau journal "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Silesian Home.")]), _vm._v(" Schütte-Lihotzky immediately understood that by connecting design to function in the kitchen, there would be a positive impact for the working woman, providing her with more time for her family and for herself.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch3fn1",
      "id": "rch3fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Using a stopwatch, Schütte-Lihotzky timed each task required within the kitchen from preparing a meal to cleaning up afterward. She then proceeded to design her trend-setting kitchen, one that became famous worldwide ("), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_11"
    }
  }, [_vm._v("Fig. 11")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_12"
    }
  }, [_vm._v("12")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_13"
    }
  }, [_vm._v("13")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Schütte-Lihotzky also designed kindergarten pavilions using Maria Montessori’s ideas. (Montessori was the first woman in Italy to qualify as a physician and founder of the Montessori Method of education.) In each of these settings, Schütte-Lihotzky can be credited as being the first to introduce the women’s perspective into architectural design. Arguably, the role model she provided can be credited for the fact that currently more than a third of practicing architects in Turkey are women!"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch3fn2",
      "id": "rch3fn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Herbert Eichholzer,")]), _vm._v(" another Austrian architect, was Schütte-Lihotzky’s colleague in Istanbul. While performing his contractual duties for Ankara’s government, he was also busy organizing Communist anti Nazi resistance at home. In 1939, Schütte-Lihotzky joined the Austrian Communist Party (KPÖ). In December 1940, she and Eichholzer returned to Vienna to secretly contact and aid the Austrian Communist resistance movement. She was arrested by the Gestapo on January 22 1941 managed to survive the war and continued to practice architecture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _vm._v("In 1946, Schütte-Lihotzky returned to Vienna, but during the Cold War, her Communist Party membership stood in the way of her winning many architectural assignments. Late in life, in 1980, she received the City of Vienna Architecture Award for her lifetime contributions, and, in 1988, she was offered the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Austrian Medal of Science and Art")]), _vm._v(" but declined it because of the alleged Nazi affiliations of Kurt Waldheim, Austria’s president at the time. She celebrated her 100th birthday in 1997, dancing a short waltz with Vienna’s mayor and remarking, “I would have enjoyed it, for a change, to design a house for a rich man.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In her memoirs, Schütte-Lihotzky tells about the years she spent in the “Resistance,” her fellow prisoners and fellow fighters, and their efforts and courage in an uncompromising solidarity which actually saved her life. Her comrade, Herbert Eicholzer, was also arrested in 1941, but he was executed in 1943 by the Gestapo. Schütte-Lihotzky escaped this fate."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch3fn3",
      "id": "rch3fn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Schütte-Lihotzky’s legacy can be found in each and every Turkish kitchen, be it in a modest apartment building flat or in a large villa. When preparing the meal or washing and putting away the dishes, one needs not to walk more than two or at most three steps front to back or side to side.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, because her tenure in Turkey had been relatively short, Margarete Schütte-Lihotzky’s imprint on Turkish architecture was in some respects not as significant as that of fellow Austrian "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clemens Holzmeister")]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_14"
    }
  }, [_vm._v("Fig. 14")]), _vm._v("). In February 1938, Holzmeister was commissioned by Atatürk to build the Republic’s Parliament building. At the time, Hitler’s troops were about to enter Austria. Because Holzmeister supported the Austrian government and fought for Austria’s independence against the Nazis, he was officially expelled from his Vienna and Dusseldorf posts. Holzmeister served as Administrator of Vienna’s Fine Arts Academy’s Architectural Section before 1938. He designed many still-functioning government buildings. From 1940 to 1954, he was Architectural Section Director at Istanbul Technical University. He designed many Turkish government buildings in Ankara, including the Grand National Assembly (1938), the ministries of Agriculture (1934), War (1931), Interior(1932), and that of the Turkish General Staff (1930) ("), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_15"
    }
  }, [_vm._v("Fig. 15")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Between 1938 and 1954, Holzmeister lived and worked in Istanbul and Ankara. He retired in 1954 and returned to Austria and served in his prior capacity at the Viennese academy up to 1957."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch3fn4",
      "id": "rch3fn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At Istanbul Technical University, he educated many of Turkey’s architects. Holzmeister never lost contact with Turkey. His last visit to Ankara, in 1978, was as a consultant on the enlargement of the Grand National Assembly complex. During his career, Holzmeister planned 700 projects in Austria, Italy, Germany, and Turkey. One of the most outstanding was the Salzburg Theatre Building.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._v("Clemens Holzmeister, the master builder and leader of the band of émigré architects, had this to say about the modernist architects’ experience in Turkey:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is solely thanks to the fact that my eleven projects were completed without the slightest cause for complaint or reproach that I increasingly gained the government’s confidence—until as the crowning achievement of my career Atatürk commissioned me to plan his private palace. The great father and founder of the New Turkey resided at that time in a modest old house in the upper part of the city.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to Holzmeister, in the first project meeting the basic issue discussed was chiefly about whether the new palace should be built on the site of the old house or alternatively next to it on a newly acquired location. When asked for his opinion, Holzmeister replied “that this old house represented a significant part of the history of the New Turkey and thereby clearly won Atatürk’s heart.” During the design and construction phase of the Presidential Palace ("), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_16"
    }
  }, [_vm._v("Fig. 16")]), _vm._v("), Holzmeister “had the opportunity to meet this outstanding personality, this man of frightening severity and the voice of a ‘Basserman/bass singer.’ ‘For him [Atatürk], the respect for the professional expert counted above everything and, if one had gained this respect through decent work, everything else was easy.’ Cheerful and proud-hearted, we did everything possible to accomplish this project, on which last but not least a large number of excellent Viennese craftsmen were employed.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch3fn5",
      "id": "rch3fn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_17"
    }
  }, [_vm._v("Fig. 17")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Among these “craftsmen” was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Martin Wagner")]), _vm._v(" who, after being discharged from his position with the City of Berlin, came to Turkey in 1934 after a short stint at Harvard on the recommendation of Walter Gropius. He stayed until 1938 and worked as an architect. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gustaf Oelsner")]), _vm._v(" was another émigré architect “who in addition to teaching architecture and city planning played an important role in actuating Turkey’s municipal planning programs.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch3fn6",
      "id": "rch3fn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Alfred Schiicking,")]), _vm._v(" a mechanical engineer, was the expert in heating and ventilation on the team. Born in 1886, a non-Jewish Austrian, he was employed without a fixed contract in the Turkish construction industry starting in 1937. Previous to that, he had worked as an assistant to Professor Taut. He was not, however, one of the university lecturers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bruno Taut")]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_18"
    }
  }, [_vm._v("Fig. 18")]), _vm._v("), too, was a member of this small and exclusive club of architects. He was responsible for the design of several public buildings in Ankara and served as Professor of Architecture at both the Istanbul Technical University and the Istanbul Academy of Fine Arts. Among "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _vm._v("others projects, he designed a building to house the Faculty of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Languages, History, and Geography,")]), _vm._v(" and was the architect who built the Ankara "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Atatürk Lycee,")]), _vm._v(" the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trabzon Lycee,")]), _vm._v(" as well as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cebeci Secondary School.")]), _vm._v(" Born in Königsberg, Germany, in 1880, he trained in Königsberg, and the Berlin Charlottenburge. Taut opened his own office in Berlin in 1910 where he maintained a busy practice until the advent of World War I. During that war, he published Pacifist polemical works, some of which came out as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Alpin Architectur")]), _vm._v(" (Alpine Architecture), showing the Alps redesigned as a gigantic task of construction, the antithesis of destructive war."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch3fn7",
      "id": "rch3fn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the late 1920s, Taut gained recognition as a leader of architecture’s “New Objective” school. He produced his book "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Modern Architecture")]), _vm._v(" in 1930. Following World War I, Germany experienced a critical housing shortage; at the same time, a Socialist ideology prevailed. Consequently various co-op housing societies and associations, public housing associations, and trade union housing groups were formed to build economical housing for the working classes in Berlin. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gehag")]), _vm._v(" (a public utility homes, savings and construction company) was one of the largest such associations. It was “founded in 1919 to build housing for its members. Committed to a progressive program of modern housing, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gehag")]), _vm._v(" sought collaboration with modern architects and, in 1924, Bruno Taut was appointed chief architect.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch3fn8",
      "id": "rch3fn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Taut was instrumental in developing the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Großsiedlungen")]), _vm._v(" (large residential community) concept for “building large garden city-type housing complexes. He had had some experience designing a similar garden city development in Magdeburg in 1912-15.” In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hufeisen")]), _vm._v(" alone, there are over 1000 two- to four-bedroom flats equally divided between three-story row houses and three-story point access slabs. Not one of the thousand is isolated, enclosed, or denied quick access and egress. Balconies opening to the opposite side dominate the garden facades. The small openings at the top floor—a normal feature of housing of this period, light an attic space that was used for washing and storage."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch3fn9",
      "id": "rch3fn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Taut emphasized glass and color in architecture even though color had been neglected by both architects and architectural historians. “Taut is unique among his European modernist contemporaries in his devotion to color.” A lifelong painter, “he applied lively, clashing colors to his first major commission, the 1912 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Falkenberg")]), _vm._v(" housing estate in Berlin, which became known as ‘Paint Box Estates.’ The 1914 Glass Pavilion, familiar from black and white reproduction, was also brightly colored.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch3fn10",
      "id": "rch3fn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Taut’s contribution to the 1927 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Weissenhofsiedlung")]), _vm._v(" housing exhibition in Stuttgart differed greatly from the pure-white Mies van der Rohe, Le Corbusier, and Walter Gropius entries. “Taut’s house Number 19 was painted up in primary colors. Mies hated it.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch3fn11",
      "id": "rch3fn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_18"
    }
  }, [_vm._v("Fig. 18")]), _vm._v(")"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch3fn12",
      "id": "rch3fn12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Taut used color for environmental, energy saving, aesthetic, and "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _vm._v("spatial effect. His approach to design was based on a belief that architecture included more than a strictly functional role, but could change and enhance the quality of life. To quote Winfried Brenne who rediscovered the colors of Taut’s Berlin apartments:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Taut always used colour to enhance architecture and give it an extra dimension. He knew that colour developed plastic effect and conferred a specific character on urban space, which helped settle it into the surrounding landscape. In everything, he strove to use colour to broaden the notion of function in architecture, in view of creating form to produce a harmonious building enhanced by a human and artistic dimension."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch3fn13",
      "id": "rch3fn13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("And, to give Taut himself the last word on the subject:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Before the war, I was denounced as a glass architect. In Magdeburg they called me the apostle of colour. The one is only a consequence of the other; for delight in light is the same as delight in colour."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch3fn14",
      "id": "rch3fn14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Glasspavillion")]), _vm._v(" building ("), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_19"
    }
  }, [_vm._v("Fig. 19")]), _vm._v(") was designed especially for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Werkbund")]), _vm._v(" Exhibition held in Cologne in 1914. Its “polygonal dome-like roof constructed of a space frame with diamond-shaped glass panels employed glass of various forms colours, and water cascades as well. It caused something of a sensation, and is his most celebrated work.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch3fn15",
      "id": "rch3fn15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" After WWI ended, Taut became the leading light of the avant-garde and exercised influence through various writings, and cultural and professional, organizations. However, after becoming Director of Building and Planning in 1921 for Marburg, a city that was the administrative center for all of Prussia and hosted a world famous university, Taut’s Expressionist and utopian tendencies withered."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch3fn16",
      "id": "rch3fn16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Taut left Germany for the USSR in 1932 and came back in February 1933 to a very hostile political environment. He first fled to Switzerland then moved to Takasaki, Japan, where he produced three influential books on Japanese culture and architecture, and did furniture and interior design work. Offered a job as Professor of Architecture at Istanbul Technical University, Taut moved to Turkey in 1936, wrote at least one more book, and designed buildings in Ankara. Of all architects foreign and domestic, Bruno Taut was given a most esteemed commission. He was chosen to design Atatürk’s catafalque. That turned out to be Taut’s last creation. He died prematurely shortly thereafter and is buried in Istanbul’s Martyr’s cemetery. Unfortunately, much of Taut’s written work was never translated into English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _vm._v("These architects are all gone, but their edifices remain for us to see. In retrospect, it appears that the Turkish reforms, at least as far as architecture is concerned, were not at all unlike the contemporaneous Nazi reforms. Though certainly nowhere near as brutal, both eliminated a high level of cultural development. Turkey’s architecture, like Germany’s science, has never recovered its respective qualitative, distinctive stylistic edge. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yildiz")]), _vm._v(" Technical University’s Architecture Professor, Ugur Tanyeli, provides a recent review and assessment of the above developments in Turkey:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("What took place in architecture and design seems to be very different from what transpired in other branches of science. In social sciences, those who came to Turkey were scholars and academicians. But almost none of those who came in the field of architecture had undergone the standard academic stages. Or a significant majority did not. A large number of these individuals came to the Academy of Fine Arts, the only school of architecture in Turkey at that period. They were real architects and designers and the reasons for their arrival were not similar to the ones of the other scholars and academicians. Anyway, nobody thought of them in the context of the university reform. They were seen as people who would implement the new architectural program of the state. The new architectural program of the state was not deeper than a quite simple, even crudely defined, idea that “in modern Turkey, there must be modern architecture.” Looking from an architectural perspective, it looks as if they [the State] brought in anybody they could find. There is no evidence that they proceeded according to certain preferences or according to the basic qualities of the people they brought in. That is, when they took in a specialist on China, he was a real Chinese specialist. But some of the architects who came were ordinary ones without any significance though some were universally acclaimed ones. It seems the method of action was to bring in whoever was available at the time. We even know that most of the time the bureaucrats were not even aware of the basic architectural tendencies of the people brought in. For example, there is a little brochure that was published by the Academy dated 1936 which includes a short explanation of the department of architecture. It says, “We have found an architect named Bruno Taut outside the country. With his arrival shortly, we will have a new instructor who will fight against the ugly cubic buildings which have invaded the provincial centers and the countryside in the name of modern architecture.” A comment so wrong and so devoid of understanding Taut’s qualities must be very rare "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _vm._v("indeed. Taut himself was a very determined Modernist. While the administration claimed that Taut was invited to fight against Modernism. This is such a comical and ignorant choice. And why did Taut really come? Very simple. Taut was both a Communist and a Jew and he was out of his country at the time. He was living in Japan and the Japanese did not create opportunities for him to stay there. Taut was obliged to accept Turkey’s invitation since he had nowhere else to go. And thus one of the principal actors of the world architectural scene arrived in Turkey by coincidence. However, Turkey was not aware of this. As we said before, the administration was expecting someone who would fight against Modernism. Many came to Turkey. Some were insignificant; some were people who should have been refused according to the ideological preferences of the period. It is interesting that many communists arrived among the architects. As an example, Margarete Schütte-Lihotzky came, a committed communist. After she went back to her country, she joined the Austrian underground and we know that she fought actively against the Nazis for many years. Margerete Schütte-Lihotzky was one of the first women architects and active communist leaders in Austria. It is interesting to note that she could teach without a problem at the Academy and could produce Primary School Programs for the Ministry of Education. She is a designer of note, even if not as important as Taut."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch3fn17",
      "id": "rch3fn17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unlike their counterparts in the sciences, economics, medicine, and law, all senior members of the architectural team came to Turkey from Austria and returned to Austria with the exception of Bruno Taut. He was born in East Prussia and is buried in Istanbul. In retrospect, they did greatly impact the life of Turkey’s urban dwellers for the better. As for the esthetics of the country’s institutional buildings which they had introduced, that is a matter of taste ("), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_20"
    }
  }, [_vm._v("Fig. 20")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch3fn18",
      "id": "rch3fn18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" and 21).")]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0051-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 8")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Blue Mosque (Sultanahmet Camii), Istanbul, Turkey. Built between 1609 and 1616 by Mehmet Aga, the imperial architect, for Sultan Ahmet I.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_9"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0051-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 9")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Within the Blue Mosque.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_10"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0052-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 10")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Margarete Schütte-Lihotzky.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_11"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0053-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 11")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("According to Schütte-Lihotzky, badly located kitchen cabinetry on the left and design with efficiently located cabinetry on the right.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_12"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0054-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 12")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Schütte-Lihotzky’s Frankfurt Kitchen: Plan and elevations.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_13"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0055-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 13")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Schütte-Lihotzky’s Frankfurt Kitchen: Isometric.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_14"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0056-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 14")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Clemens Holzmeister.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_15"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0056-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 15")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Headquarters of Turkish Armed Forces General Staff, Ankara.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_16"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0057-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 16")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Presidential Residence. Atatürk personally invited Holzmeister to design Turkey’s first Presidential residence.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_17"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0058-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 17")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("The Central Bank, Ankara.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_18"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0058-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 18")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Bruno Taut.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_19"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0059-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 19")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Taut’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Glasspavillion,")]), _vm._v(" Cologne.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_20"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0059-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 20")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Fountain of Sultan Abdülhamid I.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_21"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0060-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 21")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Entrance to the Dolmabahce Palace. The Palace was built between 1842 and 1853 on land reclaimed from the sea by Sultan Abdulmecid and designed by Nikogos Balyan, an Armenian architect and member of a three-generation dynasty designing monuments for the Ottomans.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50882b14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Chapter03.vue
// module id = 99
// module chunks = 0